import React from 'react';
import { DayViewDetail } from '../../../components/crm-calender/DayViewDetail';
import { Box, Typography } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import BookOnlineIcon from '@mui/icons-material/BookOnline';

const DayViewSummary = ({ date, appointments, setOpenAppointmentDetail}) => {
    //console.log(appointments)
    // Transform the appointments data to match the expected format
    const transformedAppointments = appointments?.length > 0
        ? appointments.map(appointment => ({
            id: appointment?.id,
            customer: {
                name: appointment?.customer?.name || 'No Name',
                ...appointment.customer
            },
            start_time: appointment.start_time,
            end_time: appointment.end_time,
            services: appointment?.service_name || [],
            type: appointment.type || 'Booking',
            notes: '',
            staff_name: appointment.staff_name || 'Staff Not Assigned',
            staff_color: appointment.staff_color || '#000000',
            status_color: appointment.status_color || '#323681',
            opacity_color: appointment.opacity_color || '#3236817f',
            payment_status: appointment.payment_status || 'Unpaid'
        }))
        : []; // Return empty array if no appointments

    return (
        <Box className="container-fluid mx-auto" sx={{py:{sm:4, xs:.2}  }}>
            <Box sx={{ my: 3 }}>
                <Typography variant="h4" className="font-bold" sx={{ fontSize:{sm:'2rem', xs:'1.5rem'}, fontWeight:'bold' }}>
                    Daily Appointment Summary
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 , flexWrap:'wrap'}}>
                    <Typography variant="h6" className="text-gray-600">
                  <CalendarMonthIcon sx={{color:'#19A2FF'}}/>      Appointments for {date.toLocaleDateString('en-US', {
                        weekday: 'long',
                        month: 'long',
                        day: 'numeric',
                        year: 'numeric'
                    })}
                    </Typography>
                    <Typography variant="h6" color="initial">
                 <BookOnlineIcon sx={{color:'#19A2FF'}}/>       Today Total Appointments: {appointments.length}
                    </Typography>
                </Box>
            </Box>

            <DayViewDetail
           setOpenAppointmentDetail={setOpenAppointmentDetail}
                appointments={transformedAppointments}
                date={date}
            />

        </Box>
    );
};

export default DayViewSummary;